var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgM2CLogHistoryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.09961 1.26889C7.36416 0.843461 6.51031 0.599976 5.59961 0.599976C2.83818 0.599976 0.599609 2.83855 0.599609 5.59998C0.599609 8.36138 2.83818 10.6 5.59961 10.6C8.36101 10.6 10.5996 8.36138 10.5996 5.59998C10.5996 4.88888 10.4512 4.21244 10.1836 3.59998",
    stroke: "#1C274C",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeDasharray: "0.25 1.75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5996 5.59998C10.5996 4.68928 10.3561 3.83541 9.93071 3.09998M5.59961 0.599976C6.51031 0.599976 7.36416 0.843461 8.09961 1.26889",
    stroke: "#1C274C",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.59961 4.09998V6.09998H7.59961",
    stroke: "#1C274C",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgM2CLogHistoryIcon);
export default __webpack_public_path__ + "static/media/m2c_log_history_icon.0134312141b151b214af49a8f9218413.svg";
export { ForwardRef as ReactComponent };